import React from 'react'

const Patch = ({ className }) => {
  return (
    <svg
      width={46}
      height={46}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2226_42920)">
        <circle cx={23} cy={23} r={23} fill="#B1B1B1" fillOpacity="0.22" />
        <rect
          className="ac-s"
          x="17.5"
          y="17.5"
          width={12}
          height={12}
          stroke="white"
        />
        <path
          className="ac-s"
          d="M15 22H19.25"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          className="ac-s"
          d="M27.75 22H32"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          className="ac-s"
          d="M15 25H19.25"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          className="ac-s"
          d="M27.75 25H32"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          className="ac-s"
          d="M22 32V28"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          className="ac-s"
          d="M22 20V16"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          className="ac-s"
          d="M25 32V28"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          className="ac-s"
          d="M25 20V16"
          stroke="white"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2226_42920">
          <rect width={46} height={46} fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Patch
